import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TONE, LABEL } from "@/pages/Training";

export function TrainingMatrix() {
  const [rows, setRows] = useState(null);
  const [role, setRole] = useState("all");
  useEffect(() => { api.get("/training/overview").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="flex h-32 items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-4 border-brand border-t-transparent" /></div>;
  const shown = rows.filter((r) => role === "all" || r.role === role);
  return (
    <div className="space-y-3" data-testid="training-matrix">
      <div className="flex gap-2">
        {[["all", "All"], ["carer", "Befrienders"], ["office", "Office"]].map(([k, l]) => (
          <button key={k} onClick={() => setRole(k)} data-testid={`matrix-filter-${k}`} className={`rounded-full px-3 py-1 text-xs font-semibold ${role === k ? "bg-ink text-white" : "bg-secondary text-ink"}`}>{l}</button>
        ))}
      </div>
      {shown.length === 0 && <p className="text-ink-muted">No staff found.</p>}
      {shown.map((r) => (
        <div key={r.user_id} data-testid={`matrix-row-${r.user_id}`} className="rounded-xl border border-border bg-white p-4 shadow-sm">
          <div className="mb-3 flex items-center gap-3">
            {r.photo ? <img src={r.photo} alt={r.name} className="h-10 w-10 rounded-full object-cover" /> : <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-light font-bold text-brand">{(r.name || "?").charAt(0)}</span>}
            <div className="flex-1"><p className="font-semibold text-ink">{r.name}</p><p className="text-xs capitalize text-ink-muted">{r.role === "carer" ? "Befriender" : r.role}</p></div>
            <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${r.done === r.total ? "bg-sage-light text-sage-dark" : "bg-gold-light text-gold-dark"}`}>{r.done}/{r.total}</span>
          </div>
          <div className="grid gap-1.5 sm:grid-cols-2">
            {r.courses.map((c) => (
              <div key={c.course_id} className="flex items-center justify-between gap-2 rounded-lg border border-border px-3 py-1.5 text-sm">
                <span className="truncate text-ink">{c.title}</span>
                <span className="flex shrink-0 items-center gap-2">
                  {c.expires_on && <span className="text-xs text-ink-muted">{c.expires_on}</span>}
                  <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${TONE[c.status]}`}>{LABEL[c.status]}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
